module.exports = __webpack_public_path__ + "img/client_logo.95b825c6.png";